import { NativeModules } from 'react-native';

const { RNZoomVideoSdkVideoStatisticInfo } = NativeModules;

/**
 * Video statistic information.
 */
export type ZoomVideoSdkVideoStatisticInfoType = {
  /**
   * Get the video's bit rate.
   */
  getBpf: () => Promise<boolean>;

  /**
   * Get the video's Frames Per Second (FPS).
   */
  getFps: () => Promise<boolean>;

  /**
   * Get the video's frame height.
   */
  getHeight: () => Promise<boolean>;

  /**
   * Get the video's frame width.
   */
  getWidth: () => Promise<boolean>;
};

export class ZoomVideoSdkVideoStatisticInfo
  implements ZoomVideoSdkVideoStatisticInfoType
{
  userId: string;

  constructor(userId: string) {
    this.userId = userId;
  }

  async getBpf() {
    return await RNZoomVideoSdkVideoStatisticInfo.getBpf(this.userId);
  }

  async getFps() {
    return await RNZoomVideoSdkVideoStatisticInfo.getFps(this.userId);
  }

  async getHeight() {
    return await RNZoomVideoSdkVideoStatisticInfo.getHeight(this.userId);
  }

  async getWidth() {
    return await RNZoomVideoSdkVideoStatisticInfo.getWidth(this.userId);
  }
}
